import { Adapter, EnvType } from './adapter';
import MSDK_V3 from './msdkv3';
import MSDK_V5 from './msdkv5';
import ItemSDK from './itemsdk';
import JSMicro from './jk';
import OutGame from './outgame';

export * from './adapter';

export const getAdapter = (env: EnvType): Adapter => {
  console.log(`[slug-share]: 正在加载 adapter[${env}]`);
  // 不使用 map 的形式，是为了便于后面根据环境变量删减不必要代码
  if (env === EnvType.MSDK_V3) {
    return new MSDK_V3();
  }
  if (env === EnvType.MSDK_V5) {
    return new MSDK_V5();
  }
  if (env === EnvType.ItemSDK) {
    return new ItemSDK();
  }
  if (env === EnvType.JKMicro) {
    return new JSMicro();
  }
  if (env === EnvType.OutGame) {
    return new OutGame();
  }
  throw '[slug-share]: adapter not found!';
};
